export var FPageNameEnum;
(function (FPageNameEnum) {
    FPageNameEnum["home"] = "home";
    FPageNameEnum["experience"] = "experience";
    FPageNameEnum["tunnel"] = "tunnel";
})(FPageNameEnum || (FPageNameEnum = {}));
export var FPagePreciseNameEnum;
(function (FPagePreciseNameEnum) {
    FPagePreciseNameEnum["experienceList"] = "experience-list";
    FPagePreciseNameEnum["experiencePage"] = "experience-page";
    FPagePreciseNameEnum["bookingTunnel"] = "booking-tunnel";
    FPagePreciseNameEnum["bookingValidation"] = "booking-validation";
    FPagePreciseNameEnum["voucherTunnel"] = "voucher-tunnel";
    FPagePreciseNameEnum["voucherValidation"] = "voucher-validation";
    FPagePreciseNameEnum["bookingConfirmation"] = "booking-confirmation";
    FPagePreciseNameEnum["voucherConfirmation"] = "voucher-confirmation";
})(FPagePreciseNameEnum || (FPagePreciseNameEnum = {}));
